import { render, staticRenderFns } from "./tigerShot.vue?vue&type=template&id=54955928"
import script from "./tigerShot.vue?vue&type=script&lang=js"
export * from "./tigerShot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports